export const white = {
  950: '#FFFFFF',
  900: '#FFFFFF',
  800: '#FFFFFF',
  700: '#FFFFFF',
  600: '#FFFFFF',
  500: '#FFFFFF',
  400: '#FFFFFF',
  300: '#FFFFFF',
  200: '#FFFFFF',
  100: '#FFFFFF',
  50: '#FFFFFF',
};

export const black = {
  950: '#000000',
  900: '#000000',
  800: '#000000',
  700: '#000000',
  600: '#000000',
  500: '#000000',
  400: '#000000',
  300: '#000000',
  200: '#000000',
  100: '#000000',
  50: '#000000',
};

export const slate = {
  950: '#020617',
  900: '#0F172A',
  800: '#1E293B',
  700: '#334155',
  600: '#475569',
  500: '#64748B',
  400: '#94A3B8',
  350: '#B1B1B7',
  300: '#CBD5E1',
  200: '#E2E8F0',
  100: '#F1F5F9',
  50: '#F8FAFC',
};

export const blue = {
  950: '#172554',
  900: '#1E3A8A',
  800: '#1E40AF',
  700: '#1D4ED8',
  600: '#2563EB',
  500: '#3B82F6',
  400: '#60A5FA',
  300: '#93C5FD',
  200: '#BFDBFE',
  150: '#C5DAFD',
  100: '#DBEAFE',
  50: '#EFF6FF',
};

export const emerald = {
  950: '#022C22',
  900: '#064E3B',
  800: '#065F46',
  700: '#047857',
  600: '#059669',
  500: '#10B981',
  400: '#34D399',
  300: '#6EE7B7',
  200: '#A7F3D0',
  100: '#D1FAE5',
  50: '#ECFDF5',
};

export const green = {
  950: '#052E16',
  900: '#14532D',
  800: '#166534',
  700: '#15803D',
  600: '#16A34A',
  500: '#22C55E',
  400: '#4ADE80',
  300: '#86EFAC',
  200: '#BBF7D0',
  100: '#DCFCE7',
  50: '#F0FDF4',
};

export const amber = {
  950: '#451A03',
  900: '#78350F',
  800: '#92400E',
  700: '#B45309',
  600: '#D97706',
  500: '#F59E0B',
  400: '#FBBF24',
  300: '#FCD34D',
  200: '#FDE68A',
  100: '#FEF3C7',
  50: '#FFFBEB',
};

export const red = {
  950: '#450A0A',
  900: '#7F1D1D',
  800: '#991B1B',
  700: '#B91C1C',
  600: '#DC2626',
  500: '#EF4444',
  400: '#F87171',
  300: '#FCA5A5',
  200: '#FECACA',
  100: '#FEE2E2',
  50: '#FEF2F2',
};

export const yellow = {
  950: '#422006',
  900: '#713f12',
  800: '#854d0e',
  700: '#a16207',
  600: '#ca8a04',
  500: '#eab308',
  400: '#facc15',
  300: '#fde047',
  200: '#fef08a',
  100: '#fef9c3',
  50: '#fefce8',
};

export const orange = {
  950: '#431407',
  900: '#7c2d12',
  800: '#9a3412',
  700: '#ea580c',
  600: '#ea580c',
  500: '#f97316',
  400: '#fb923c',
  300: '#fdba74',
  200: '#fed7aa',
  100: '#ffedd5',
  50: '#fff7ed',
};

export const neutral = {
  900: '#111827',
  700: '#374151',
};

export const pink = {
  300: '#F9A8D4',
  500: '#EC4899',
};

/** Tailwind-aligned purple (public search AI accents / gradients) */
/** Pedigree / non-chart sex node accent (female) */
export const pedigreeFemale = '#EE66A3';

export const purple = {
  50: '#faf5ff',
  100: '#f3e8ff',
  200: '#e9d5ff',
  300: '#d8b4fe',
  400: '#c084fc',
  500: '#a855f7',
  600: '#9333ea',
  700: '#7e22ce',
  800: '#6b21a8',
  900: '#581c87',
  950: '#3b0764',
};
